import LegalLayout from './LegalLayout';

const ConfidentialitePage = () => (
  <LegalLayout title="Politique de confidentialité">
    <p data-testid="legal-privacy-intro">
      La présente politique décrit la manière dont <strong>Ô'Délicieuse SRL</strong> (ci-après
      « nous ») collecte, utilise et protège vos données personnelles lorsque vous utilisez
      le site <strong>odelicieuse.eu</strong>. Nous nous conformons au Règlement Général sur la
      Protection des Données (RGPD — UE 2016/679).
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">1. Responsable du traitement</h2>
    <p>
      Ô'Délicieuse SRL — Rue Marie-Christine 32, 1020 Bruxelles, Belgique<br />
      Contact : contact@odelicieuse.eu — +32 493 32 88 62
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">2. Données collectées</h2>
    <p>Nous collectons uniquement les données strictement nécessaires :</p>
    <ul className="list-disc pl-6 space-y-1">
      <li><strong>Compte client</strong> : nom, téléphone, adresse email, mot de passe (chiffré)</li>
      <li><strong>Commandes</strong> : produits commandés, quantités, adresse de livraison, notes éventuelles</li>
      <li><strong>Navigation</strong> : pages visitées, produits consultés (à des fins statistiques internes)</li>
      <li><strong>Cookies techniques</strong> : session et préférences (langue, thème)</li>
    </ul>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">3. Finalités du traitement</h2>
    <ul className="list-disc pl-6 space-y-1">
      <li>Gérer votre compte client et vos commandes</li>
      <li>Vous contacter concernant votre commande (confirmation, expédition, livraison) par email ou WhatsApp</li>
      <li>Émettre les factures et respecter nos obligations comptables</li>
      <li>Améliorer le site grâce à des statistiques d'usage anonymisées</li>
      <li>Prévenir la fraude et garantir la sécurité du service</li>
    </ul>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">4. Bases légales</h2>
    <ul className="list-disc pl-6 space-y-1">
      <li><strong>Exécution du contrat</strong> — pour la gestion de votre compte et de vos commandes</li>
      <li><strong>Obligation légale</strong> — pour la conservation comptable et fiscale</li>
      <li><strong>Intérêt légitime</strong> — pour l'amélioration du site et la prévention des fraudes</li>
      <li><strong>Consentement</strong> — pour les cookies non essentiels, que vous pouvez retirer à tout moment</li>
    </ul>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">5. Destinataires des données</h2>
    <p>Vos données ne sont jamais vendues. Elles peuvent être partagées uniquement avec :</p>
    <ul className="list-disc pl-6 space-y-1">
      <li>Notre équipe interne (préparation, expédition, support)</li>
      <li>Nos prestataires techniques sous contrat (hébergement, envoi d'emails transactionnels via Resend)</li>
      <li>Les transporteurs, uniquement pour vous livrer</li>
      <li>Les autorités publiques, en cas d'obligation légale</li>
    </ul>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">6. Durée de conservation</h2>
    <ul className="list-disc pl-6 space-y-1">
      <li>Données de compte : tant que votre compte est actif, puis 3 ans après la dernière activité</li>
      <li>Commandes et factures : 10 ans (obligation comptable)</li>
      <li>Cookies : durée définie dans notre politique cookies</li>
    </ul>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">7. Vos droits RGPD</h2>
    <p>Vous disposez à tout moment des droits suivants :</p>
    <ul className="list-disc pl-6 space-y-1">
      <li><strong>Droit d'accès</strong> à vos données</li>
      <li><strong>Droit de rectification</strong> de données inexactes</li>
      <li><strong>Droit à l'effacement</strong> (« droit à l'oubli »)</li>
      <li><strong>Droit à la limitation</strong> du traitement</li>
      <li><strong>Droit à la portabilité</strong> de vos données</li>
      <li><strong>Droit d'opposition</strong> au traitement</li>
      <li><strong>Droit de retirer votre consentement</strong> à tout moment</li>
    </ul>
    <p>
      Pour exercer ces droits : contactez-nous à <strong>contact@odelicieuse.eu</strong>.
      Vous avez également le droit d'introduire une réclamation auprès de l'
      <a
        href="https://www.autoriteprotectiondonnees.be"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[color:var(--color-primary)] hover:underline"
      >
        Autorité de Protection des Données belge
      </a>.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">8. Sécurité</h2>
    <p>
      Vos données sont stockées sur des serveurs sécurisés au sein de l'Union européenne. Nous
      mettons en œuvre des mesures techniques et organisationnelles appropriées (chiffrement
      des mots de passe, connexions HTTPS, contrôles d'accès) pour protéger vos données contre
      tout accès non autorisé, modification ou divulgation.
    </p>

    <h2 className="text-xl font-semibold text-heading mt-6 mb-2">9. Transferts hors UE</h2>
    <p>
      Certains prestataires techniques (comme Resend pour l'envoi d'emails) peuvent stocker
      temporairement des données dans des pays hors Union européenne. Ces transferts sont
      encadrés par des clauses contractuelles types approuvées par la Commission européenne.
    </p>

    <p className="text-xs text-muted mt-8 italic">
      Dernière mise à jour : {new Date().toLocaleDateString('fr-BE', { day: '2-digit', month: 'long', year: 'numeric' })}.
    </p>
  </LegalLayout>
);

export default ConfidentialitePage;
